<template>
  <div class="border">
    <h4>{{ "purchases" | setText("Товары заказа") }}</h4>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      title_add="Добавить товар в заказ"
      title_add_key="add_product"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="false"
      :isAdd="true"
      :openItem="false"
      :itemLink="itemLink"
      :setLink="setLink"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @input="change"
      @changeFunction="changeFunction"
      @deleted="$emit('deleted', true)"
      v-model="val"
    />
    <hr />
    <h4>
      <span class="text-info">Итого на оплату:</span>
      {{ order.price_total | spaceBetweenNumber }} UZS
    </h4>

    <services :id="id" />
  </div>
</template>
<script>
import { logger } from "../../../plugins/functions";

export default {
  components: {
    services: () => import("./Services"),
  },
  name: "products",
  props: {
    id: {
      default: null,
    },
    order: {
      default: null,
    },
  },
  created() {
    this.itemLink = `orders/${this.id}/purchases`;
    this.setLink = `orders/${this.id}/purchases`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {
      // logger(this.$http,{name:`Изменение  товаров в заказе` , description: `Заказ #cb_order_${this.id}`});
    },
  },
  data() {
    return {
      val: [],
      modalCreate: "purchase",
      fields: [
        {
          label: "Товар",
          key: "variant",
          labelKey: "product",
          type: "select",
          modal: "variant",
          selectKey: "name",
        },
        {
          label: "Количество",
          key: "quantity",
          labelKey: "quantity",
          type: "field",
          textType: "number",
          default: "1",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_purchase",
      itemLink: "purchases",
      setLink: "purchases",
      columns: [
        {
          key: "name",
          titleKey: "product",
          title: "Товар",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "price_fix",
          titleKey: "price_1",
          title: "Цена за 1 ед.",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          price: true,
        },
        {
          key: "quantity",
          titleKey: "qty",
          title: "Кол-во",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "discount_total",
          titleKey: "discount_total",
          title: "Скидка (итого)",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          price: true,
        },

        {
          key: "price_total",
          titleKey: "price_total",
          title: "Общая стоимость",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          price: true,
        },
        // {
        //   key: "discount",
        //   titleKey: "discount",
        //   title: "Скидка",
        //   checkbox: false,
        //   control: false,
        //   align: "left",
        //   timer: false,
        //   detail: false,
        // },

        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
